export default __webpack_public_path__ + "static/media/phone.94a7a4fe.svg";